/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeBreakpointContext,
  BaSeDialogContext,
  BaSeHeading4,
  BaSeHeading5,
  BaSeParagraph,
  BaSeStepper,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { useAnswerController } from '../../../../hooks/controllers/answer-controller';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useMessage } from '../../../../hooks/messages/useMessage';
import Button from '../button';
import { useFilter } from './hook/useFilter';
import {
  AlignText,
  ButtonWrapper,
  Circulo,
  ContainerMessages,
  Content,
  ContentSelectionInterview,
  ContentStepperThree,
  ContentWrapper,
  Separator,
  StepperContainer,
  StepperContent,
  TextHeaderWrapper,
} from './selection-interview-styled';
import { StepContent } from './step-content';
import { useDialogsTutoriais } from './tutorial/tutoriais';

const NEXT = 'PRÓXIMA';
const BACK = 'VOLTAR';
const SEND = 'ENVIAR ENTREVISTA';

const wordSeparatorRegEx =
  /(!([^\s0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+|\s|[-–@.,][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+/gim;

const clearValueToFilterWord = (value = '') => {
  return value
    .trim()
    .replace(/^[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+/gim, '')
    .replace(/[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+$/gim, '');
};
// const returnMessagesFilters = (item) => {
//   const messages = new Map();
//   const words = item?.obs?.disapprovedWords || [];

//   const messageRepetition = `Notamos que a(s) palavra(s) ${words
//     .map((it) => `"${it.word}"`)
//     .join(',')} se repete(m) várias vezes.`;
//   const messageFirst = 'Não ter sido iniciada com o pronome "Eu"';
//   const messagePlagiarized = 'De autoria de terceiros. (Plágio)';

//   messages.set('FIRST', messageFirst);
//   messages.set('REPETITION', messageRepetition);
//   messages.set('PLAGIARIZED', messagePlagiarized);

//   return messages.get(item.typeTestSpeck);
// };

export const SelectionInterview = ({
  interview,
  answers: ansrweData,
  pageSettings,
}) => {
  const breakpointController = React.useContext(BaSeBreakpointContext);
  const { navigateTo } = Sebrae.useSebraeRouter();
  const { handleAttention, handleCustomAlert, handleError } = useMessage();

  const {
    prepareAnswers,
    updateAnswer,
    sendAnswerInterview,
    getAnswersByInterview,
    validateAnswersFilter,
  } = useAnswerController();
  const { getHasAnyFilterActive } = useInterviewController();

  const [answers, setAnswers] = React.useState([]);

  const [lengthStep, setLengthStep] = React.useState(0);

  const [currentStep, setCurrentStep] = React.useState(1);
  const [isStepChangeInvalid, setIsStepChangeInvalid] = React.useState(false);
  const [isAudioListening, setIsAudioListening] = React.useState(false);
  const [salved, setSalved] = React.useState(false);

  const [completedOne, setCompletedOne] = React.useState(false);
  const [completedTwo, setCompletedTwo] = React.useState(false);
  const [completedThree, setCompletedThree] = React.useState(false);
  const [completedFour, setCompletedFour] = React.useState(false);
  const [completedFive, setCompletedFive] = React.useState(false);

  const [answerOne, setAnswerOne] = React.useState({});
  const [answerTwo, setAnswerTwo] = React.useState({});
  const [answerThree, setAnswerThree] = React.useState({});
  const [answerFour, setAnswerFour] = React.useState({});
  const [answerFive, setAnswerFive] = React.useState({});
  const [analyzingAnswer, setAnalyzingAnswer] = React.useState(false);
  const [permissionToValidateFilter, setPermissionToValidateFilter] =
    React.useState(false);

  const orientation = breakpointController.inTablet ? 'horizontal' : 'vertical';
  const { showDialogDica1 } = useDialogsTutoriais(pageSettings);
  const { showModal } = React.useContext(BaSeDialogContext);

  const { returnMessagesFilters } = useFilter();

  const steps = React.useMemo(
    () => [
      { isCompleted: completedOne },
      { isCompleted: completedTwo },
      { isCompleted: completedThree },
      { isCompleted: completedFour },
      { isCompleted: completedFive },
    ],
    [completedFive, completedFour, completedOne, completedThree, completedTwo],
  );

  const getAnswers = React.useCallback(() => {
    return [answerOne, answerTwo, answerThree, answerFour, answerFive];
  }, [answerFive, answerFour, answerOne, answerThree, answerTwo]);

  const wordCounter = React.useCallback((value) => {
    const cleanValue = clearValueToFilterWord(value);
    if (!cleanValue) {
      return 0;
    }
    const splittedValue = cleanValue.split(wordSeparatorRegEx);
    const filteredVaue = splittedValue.filter(
      (val) => !!clearValueToFilterWord(val),
    );
    const { length } = filteredVaue;
    return length;
  }, []);

  const validAnswer = React.useCallback(
    (item) => {
      const length = wordCounter(item.answer);
      setLengthStep(length);

      return item?.answer && length >= 120;
    },
    [wordCounter],
  );

  const onCompletedStep = React.useCallback(
    (answer) => {
      if (answer?.question?.id) {
        const setCompletedMap = {
          1: setCompletedOne,
          2: setCompletedTwo,
          3: setCompletedThree,
          4: setCompletedFour,
          5: setCompletedFive,
        };
        setCompletedMap[answer.question.id](validAnswer(answer));
      }
    },
    [validAnswer],
  );

  const getAnswer = React.useCallback(
    (step) => {
      const answerMap = {
        1: answerOne,
        2: answerTwo,
        3: answerThree,
        4: answerFour,
        5: answerFive,
      };
      return answerMap[step];
    },
    [answerFive, answerFour, answerOne, answerThree, answerTwo],
  );

  const enviarQuestoes = React.useCallback(
    (answersData) => {
      const data = { idInterview: interview?.id, answers: getAnswers() };

      sendAnswerInterview(data, interview?.module.id)
        .then(() => {
          navigateTo(`/candidato/resultado/id/${data.idInterview}`, {
            keepQueryString: true,
          });
        })
        .catch((error) => {
          console.error('Falha ao enviar entrevista para analise', error);
          navigateTo(`/candidato/resultado/id/${data.idInterview}`, {
            keepQueryString: true,
          });
        });
    },
    [interview, getAnswers, sendAnswerInterview, navigateTo],
  );

  const nextStepState = React.useCallback((step) => {
    setIsStepChangeInvalid(false);
    if (step !== undefined) {
      setCurrentStep(step);
      return;
    }
    setCurrentStep((actualStep) => actualStep + 1);
  }, []);

  const generateMessage = React.useCallback(
    (data, messageRepetition) => {
      if (!data) return;
      return (
        <ContainerMessages>
          {data.map((item) => {
            return (
              <AlignText
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 8,
                }}
              >
                <Circulo />
                <BaSeParagraph
                  color={BaSeTheme.colors.institucionais.cinzaSebrae45}
                >
                  {item.typeTestSpeck === 'REPETITION' && (
                    <>
                      Palavra(s) em repetição.
                      <br />
                    </>
                  )}
                  {returnMessagesFilters(item, messageRepetition)}
                </BaSeParagraph>
              </AlignText>
            );
          })}
        </ContainerMessages>
      );
    },
    [returnMessagesFilters],
  );

  const openDialogFilterAnswer = React.useCallback(
    (data, atualStep, actionCall, dataFilter, messageRepetition) => {
      return showModal({
        actions: [
          {
            action: 'Revisar',
            type: 'primary',
            color: BaSeTheme.colors.institucionais.cinzaSebrae10,
          },
          {
            action: 'Avançar',
            type: 'secondary',
          },
        ],
        size: 'small',
        title: 'Atenção',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <div>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Identificamos inconsistência(s) em sua resposta:
            </BaSeParagraph>
            <br />
            {generateMessage(dataFilter, messageRepetition)}
            <br />
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Somente se o texto for de sua autoria e tiver passado por sua
              revisão, clique em "Avançar" ou caso deseje, clique em "Revisar"
              para revisar sua resposta.
            </BaSeParagraph>
          </div>
        ),
        onChooseAction: (action) => {
          if (action === 'Revisar') {
          }
          if (action === 'Avançar') {
            if (actionCall === 'sendInterview') {
              enviarQuestoes(data);
            } else if (actionCall === 'onStepChange') {
              nextStepState(atualStep);
            } else {
              nextStepState();
            }
          }
        },
      });
    },
    [enviarQuestoes, generateMessage, nextStepState, showModal],
  );

  const redirectActionCall = React.useCallback(
    (actionCall, atualStep, data) => {
      if (actionCall === 'sendInterview') {
        enviarQuestoes(data);
        return;
      }

      if (actionCall === 'nextStep') {
        nextStepState();
        return;
      }

      if (atualStep !== undefined) {
        // nextStepState(atualStep);
        setCurrentStep(atualStep);
        return;
      }
    },
    [enviarQuestoes, nextStepState],
  );

  const analisandoResposta = React.useCallback(
    async (answer, data, atualStep, actionCall) => {
      try {
        const { hasAnyActiveFilter } = await getHasAnyFilterActive();

        if (hasAnyActiveFilter) {
          setAnalyzingAnswer(true);
          handleCustomAlert(
            'Estamos analisando a sua resposta.',
            'Aguarde alguns instantes.',
          );

          const response = await validateAnswersFilter(answer.id);

          const filterNotPassed = response.filter(
            (item) => item.passed !== undefined && !item.passed,
          );

          if (filterNotPassed.length > 0) {
            const obsDisaprovedWords = filterNotPassed.filter(
              (it) => it.obs !== undefined && it.obs.disapprovedWords,
            );

            if (obsDisaprovedWords.length > 0) {
              const words = obsDisaprovedWords.flatMap((item) =>
                item.obs.disapprovedWords.map((wordObj) => `"${wordObj.word}"`),
              );

              const message = new Intl.ListFormat('pt-BR', {
                style: 'long',
                type: 'conjunction',
              }).format(words);

              openDialogFilterAnswer(
                data,
                atualStep,
                actionCall,
                filterNotPassed,
                message,
              );
              return;
            }
          }

          redirectActionCall(actionCall, atualStep, data);
        } else if (actionCall === 'sendInterview' && atualStep === 5) {
          enviarQuestoes(data);
        } else {
          redirectActionCall(actionCall, atualStep, data);
        }
      } catch (error) {
        handleError('Erro em verificar se o filtro está ativo.');
      } finally {
        setAnalyzingAnswer(false);
        setPermissionToValidateFilter(false);
      }
    },
    [
      enviarQuestoes,
      getHasAnyFilterActive,
      handleCustomAlert,
      handleError,
      openDialogFilterAnswer,
      redirectActionCall,
      validateAnswersFilter,
    ],
  );

  const checkValidateFilter = React.useCallback(
    async (answer, atualStep, actionCall) => {
      const data = { idInterview: interview?.id, answers: getAnswers() };
      if (answer?.answer === undefined || !validAnswer(answer)) {
        redirectActionCall(actionCall, atualStep, data);
        return;
      }

      getHasAnyFilterActive()
        .then(({ hasAnyActiveFilter }) => {
          if (hasAnyActiveFilter) {
            analisandoResposta(answer, data, atualStep, actionCall);
          } else if (actionCall === 'sendInterview' && atualStep === 5) {
            enviarQuestoes(data);
          } else {
            redirectActionCall(actionCall, atualStep, data);
          }
        })
        .catch((error) => {
          handleError('Erro em verificar se o filtro está ativo.');
        });
    },
    [
      interview.id,
      getAnswers,
      validAnswer,
      getHasAnyFilterActive,
      redirectActionCall,
      analisandoResposta,
      enviarQuestoes,
      handleError,
    ],
  );

  const sendInterview = React.useCallback(() => {
    onCompletedStep(answerFive);

    const isInvalid = steps.some((step, index) => {
      return (index < 4 && !step.isCompleted) || !validAnswer(answerFive);
    });

    if (isInvalid) {
      setIsStepChangeInvalid(true);
      handleAttention('É necessário concluir todas as etapas para continuar.');
      return;
    }

    if (!salved) {
      return;
    }
    checkValidateFilter(answerFive, currentStep, 'sendInterview');

    // enviarQuestoes(data);
    // sendAnswerInterview({ idInterview: interview?.id, answers: getAnswers() })
    //   .then(() => {
    //     console.log('Entrevista enviada para analise');
    //     navigateTo('/candidato/resultado/' + token, { keepQueryString: true });
    //   })
    //   .catch((error) => {
    //     console.error('Falha ao enviar entrevista para analise', error);
    //     navigateTo('/candidato/resultado/' + token, { keepQueryString: true });
    //     navigateTo('/candidato/resultado/' + token, { keepQueryString: true });
    //   });
  }, [
    answerFive,
    checkValidateFilter,
    currentStep,
    handleAttention,
    onCompletedStep,
    salved,
    steps,
    validAnswer,
  ]);

  const saveAnswer = React.useCallback(
    (actualAnswer, setSalved) => {
      updateAnswer(actualAnswer, setSalved);
    },
    [updateAnswer],
  );

  const onStepChange = React.useCallback(
    (step) => {
      const currrentAnswer = getAnswer(currentStep);
      onCompletedStep(currrentAnswer);

      for (let index = 1; index <= step; index++) {
        const answer = getAnswer(index);

        onCompletedStep(answer);

        if (index < step && !validAnswer(answer)) {
          setIsStepChangeInvalid(true);
          return;
        }
      }

      if (isAudioListening) {
        return;
      }

      if (currrentAnswer.answer && !salved) {
        return;
      }

      if (!permissionToValidateFilter) {
        const data = { idInterview: interview?.id, answers: getAnswers() };
        redirectActionCall('onStepChange', step, data);
        return;
      }

      if (currentStep !== step) {
        checkValidateFilter(currrentAnswer, step, 'onStepChange');
      }

      // setCurrentStep(step);
      setIsStepChangeInvalid(false);
    },
    [
      checkValidateFilter,
      currentStep,
      getAnswer,
      getAnswers,
      interview,
      isAudioListening,
      onCompletedStep,
      permissionToValidateFilter,
      redirectActionCall,
      salved,
      validAnswer,
    ],
  );

  const nextStep = React.useCallback(
    (step) => {
      const answer = getAnswer(step);

      onCompletedStep(answer);

      if (!validAnswer(answer)) {
        setIsStepChangeInvalid(true);
        return;
      }

      if (isAudioListening) {
        return;
      }

      if (!salved) {
        return;
      }

      if (!permissionToValidateFilter) {
        const data = { idInterview: interview?.id, answers: getAnswers() };
        redirectActionCall('nextStep', step, data);
        return;
      }

      checkValidateFilter(answer, step, 'nextStep');

      setIsStepChangeInvalid(false);
    },
    [
      checkValidateFilter,
      getAnswer,
      getAnswers,
      interview,
      isAudioListening,
      onCompletedStep,
      permissionToValidateFilter,
      redirectActionCall,
      salved,
      validAnswer,
    ],
  );

  const backStep = React.useCallback(
    (step) => {
      const answer = getAnswer(step);

      onCompletedStep(answer);
      if (answer.answer === undefined) {
        setCurrentStep(step - 1);
        return;
      }

      // if (!validAnswer(answer)) {
      //   setIsStepChangeInvalid(true);
      //   return;
      // }

      if (isAudioListening) {
        return;
      }

      if (!salved) {
        return;
      }

      if (!permissionToValidateFilter) {
        const data = { idInterview: interview?.id, answers: getAnswers() };
        redirectActionCall(undefined, step - 1, data);
        return;
      }

      // checkValidateFilter(answer, step - 1, 'onStepChange');
      checkValidateFilter(answer, step - 1, 'onStepChange');

      setIsStepChangeInvalid(false);

      // setCurrentStep((actualStep) => actualStep - 1);
    },
    [
      checkValidateFilter,
      getAnswer,
      getAnswers,
      interview,
      isAudioListening,
      onCompletedStep,
      permissionToValidateFilter,
      redirectActionCall,
      salved,
    ],
  );
  React.useEffect(() => {
    if (!interview.id) return;

    const fetchAnswers = async () => {
      try {
        const answers = await prepareAnswers(interview.id);
        setAnswers(answers);
      } catch (error) {
        console.error(error);
        setAnswers([]);
        handleError('Erro no preparo da etapa de entrevista de seleção.');
      }
    };

    fetchAnswers();
  }, [handleError, interview.id, prepareAnswers]);

  React.useEffect(() => {
    answers.forEach((answer) => {
      if (answer.question.id === 1) {
        setAnswerOne(answer);
        onCompletedStep(answer);
      }
      if (answer.question.id === 2) {
        setAnswerTwo(answer);
        onCompletedStep(answer);
      }
      if (answer.question.id === 3) {
        setAnswerThree(answer);
        onCompletedStep(answer);
      }
      if (answer.question.id === 4) {
        setAnswerFour(answer);
        onCompletedStep(answer);
      }
      if (answer.question.id === 5) {
        setAnswerFive(answer);
        onCompletedStep(answer);
      }
    });

    const stepInFilling = answers
      .sort((a, b) => b.question.id - a.question.id)
      .filter((item) => !validAnswer(item))
      .pop()?.question.id;

    stepInFilling ? setCurrentStep(stepInFilling) : setCurrentStep(1);
  }, [
    interview,
    answers,
    handleError,
    onCompletedStep,
    prepareAnswers,
    validAnswer,
  ]);

  React.useEffect(() => {
    getAnswersByInterview(interview?.id)
      .then((response) => {
        if (response.length === 0) {
          return showDialogDica1();
        }
        for (let index = 0; index < response.length; index++) {
          if (response[index]?.question?.id === 1 && !response[index].answer) {
            showDialogDica1();
            return;
          }
        }
      })
      .catch(console.error);
  }, [getAnswersByInterview, interview, showDialogDica1]);

  return (
    <Content>
      <ContentStepperThree>
        <TextHeaderWrapper>
          <BaSeHeading4
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae97}
          >
            Entrevista de seleção
          </BaSeHeading4>
          <BaSeHeading5
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae75}
          >
            Essa etapa consiste numa entrevista em que iremos conhecer um pouco
            mais sobre seu perfil empreendedor, para assim avaliar sua
            participação no seminário.
          </BaSeHeading5>
        </TextHeaderWrapper>
        <ContentWrapper>
          <ContentSelectionInterview>
            {currentStep === 1 && (
              <>
                <BaSeHeading5
                  color={BaSeTheme.colors.institucionais.cinzaSebrae45}
                >
                  Iremos lhe apresentar cinco situações e para cada uma delas
                  você deverá relatar um fato real em que você foi o agente
                  principal do acontecimento. <br /> <br />
                  As situações podem ser de​ sua vida empresarial, sendo estas
                  mais ricas para nossa análise, ou de outros fatos que devem
                  ter princípio, meio e fim. ​ <br /> <br />
                  Tais fatos podem ser de um passado remoto ou recente, mas é
                  importante que você se recorde de detalhes e que se sinta à
                  vontade para relatá-los.
                </BaSeHeading5>
                <Separator />
              </>
            )}

            <StepperContainer orientation={orientation}>
              <BaSeStepper
                steps={steps}
                onStepChange={(step) => onStepChange(step)}
                currentStep={currentStep}
                orientation={orientation}
              />
              <StepperContent>
                {currentStep === 1 && (
                  <StepContent
                    question={currentStep}
                    answer={answerOne}
                    isStepChangeInvalid={isStepChangeInvalid}
                    setIsStepChangeInvalid={setIsStepChangeInvalid}
                    validAnswer={validAnswer}
                    onAnswerChange={setAnswerOne}
                    saveAnswer={saveAnswer}
                    setIsAudioListening={setIsAudioListening}
                    validateCompleteAnswer={onCompletedStep}
                    lengthStep={lengthStep}
                    salved={salved}
                    setSalved={setSalved}
                    wordCounter={wordCounter}
                    setPermissionToValidateFilter={
                      setPermissionToValidateFilter
                    }
                  />
                )}
                {currentStep === 2 && (
                  <StepContent
                    question={currentStep}
                    answer={answerTwo}
                    isStepChangeInvalid={isStepChangeInvalid}
                    setIsStepChangeInvalid={setIsStepChangeInvalid}
                    validAnswer={validAnswer}
                    onAnswerChange={setAnswerTwo}
                    saveAnswer={saveAnswer}
                    setIsAudioListening={setIsAudioListening}
                    validateCompleteAnswer={onCompletedStep}
                    lengthStep={lengthStep}
                    salved={salved}
                    setSalved={setSalved}
                    wordCounter={wordCounter}
                    setPermissionToValidateFilter={
                      setPermissionToValidateFilter
                    }
                  />
                )}
                {currentStep === 3 && (
                  <StepContent
                    question={currentStep}
                    answer={answerThree}
                    isStepChangeInvalid={isStepChangeInvalid}
                    setIsStepChangeInvalid={setIsStepChangeInvalid}
                    validAnswer={validAnswer}
                    onAnswerChange={setAnswerThree}
                    saveAnswer={saveAnswer}
                    setIsAudioListening={setIsAudioListening}
                    validateCompleteAnswer={onCompletedStep}
                    lengthStep={lengthStep}
                    salved={salved}
                    setSalved={setSalved}
                    wordCounter={wordCounter}
                    setPermissionToValidateFilter={
                      setPermissionToValidateFilter
                    }
                  />
                )}
                {currentStep === 4 && (
                  <StepContent
                    question={currentStep}
                    answer={answerFour}
                    isStepChangeInvalid={isStepChangeInvalid}
                    setIsStepChangeInvalid={setIsStepChangeInvalid}
                    validAnswer={validAnswer}
                    onAnswerChange={setAnswerFour}
                    saveAnswer={saveAnswer}
                    setIsAudioListening={setIsAudioListening}
                    validateCompleteAnswer={onCompletedStep}
                    lengthStep={lengthStep}
                    salved={salved}
                    setSalved={setSalved}
                    wordCounter={wordCounter}
                    setPermissionToValidateFilter={
                      setPermissionToValidateFilter
                    }
                  />
                )}
                {currentStep === 5 && (
                  <StepContent
                    question={currentStep}
                    answer={answerFive}
                    isStepChangeInvalid={isStepChangeInvalid}
                    setIsStepChangeInvalid={setIsStepChangeInvalid}
                    validAnswer={validAnswer}
                    onAnswerChange={setAnswerFive}
                    saveAnswer={saveAnswer}
                    setIsAudioListening={setIsAudioListening}
                    validateCompleteAnswer={onCompletedStep}
                    lengthStep={lengthStep}
                    salved={salved}
                    setSalved={setSalved}
                    wordCounter={wordCounter}
                    setPermissionToValidateFilter={
                      setPermissionToValidateFilter
                    }
                  />
                )}
              </StepperContent>
            </StepperContainer>
          </ContentSelectionInterview>
        </ContentWrapper>
      </ContentStepperThree>
      <ButtonWrapper>
        {currentStep !== 1 && (
          <Button
            calback={() => backStep(currentStep)}
            value={BACK}
            valueSmall={BACK}
            color={pageSettings?.buttonColor}
            withBorder={true}
            borderColor={pageSettings?.buttonBorderColor}
            loading={analyzingAnswer}
          />
        )}
        <Button
          calback={() =>
            currentStep === 5 ? sendInterview() : nextStep(currentStep)
          }
          value={currentStep !== 5 ? NEXT : SEND}
          valueSmall={currentStep !== 5 ? NEXT : SEND}
          color={pageSettings?.buttonColor}
          withBorder={true}
          borderColor={pageSettings?.buttonBorderColor}
          loading={analyzingAnswer}
        />
      </ButtonWrapper>
    </Content>
  );
};
